import { render, staticRenderFns } from "./AdvancedPromotionsV2.vue?vue&type=template&id=0b231d61&scoped=true&"
import script from "./AdvancedPromotionsV2.vue?vue&type=script&lang=js&"
export * from "./AdvancedPromotionsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b231d61",
  null
  
)

export default component.exports